export default __webpack_public_path__ + "static/media/legend_300.a5d66fa9.webp";